define('controller/disclosure/disclosure.form.tab.controller',['require','exports','module','controller/disclosure/disclosure.tab.controller','formkit/formkit','model/disclosure.detail.model','model/document.answer.model','model/review.person.model','model/person.model','model/user.model','model/previous.reviewer.model','model/disclosure.routing.history.model','model/template.state.model','model/template.type.model','fukit','model/outcome.model','model/disclosure.comment.model','model/settings.model','view/disclosure/disclosure.form.tab.page.view'],function(require, exports, module) {
  //prettier-ignore
  var DisclosureTabController       = require('controller/disclosure/disclosure.tab.controller'),
      FormKit                       = require('formkit/formkit'),

      DisclosureDetailModel         = require('model/disclosure.detail.model'),
      DocumentAnswerModel           = require('model/document.answer.model'),
      ReviewerPersonModel           = require('model/review.person.model'),
      PersonModel                   = require('model/person.model'),
      UserModel                     = require('model/user.model'),
      PreviousReviewerModel         = require('model/previous.reviewer.model'),
      DisclosureRoutingHistoryModel = require('model/disclosure.routing.history.model'),
      TemplateStateModel            = require('model/template.state.model'),
      TemplateTypeModel             = require('model/template.type.model'),
      ResourceQueryCollection       = require('fukit').ResourceQueryCollection,
      OutcomeModel                  = require('model/outcome.model'),
      DisclosureCommentModel        = require('model/disclosure.comment.model'),
      SettingsModel                 = require('model/settings.model'),

      DisclosureFormTabPageView     = require('view/disclosure/disclosure.form.tab.page.view');

  var DisclosureFormTabController = DisclosureTabController.extend({
    radioRequests: {
      'controllers DisclosureFormTabController': '@constructor',
    },

    pageView: DisclosureFormTabPageView,

    //Create the form and set it as a pageview option to make it available to BlocKit
    pageViewOptions: function() {
      return {
        form: this.createForm(),
      };
    },

    resources: {
      //Form related models
      templateType: {
        model: TemplateTypeModel,
      },
      template: {
        fetchOnStart: true,
        model: TemplateStateModel,
        attrs: {
          id: '@state.primaryId',
        },
      },
      documentAnswers: {
        collection: DocumentAnswerModel.BulkSaveCollection,
      },
      formPermissionModel: {
        model: Backbone.Model,
      },

      // Disclosure related models
      disclosure: {
        fetchOnStart: true,
        model: DisclosureDetailModel,
        attrs: {
          id: '@state.primaryId',
        },
      },
      disclosureAssignmentDetailModel: {
        resourcePath: '@resources.disclosure.assignmentDetailModel',
      },

      // Workflow related models and collections
      workflowActivityStateModel: {
        model: Backbone.Model,
      },
      workflowTaskModel: {
        required: false,
        resourcePath: '@resources.disclosure.workflowTaskModel',
      },
      availableReviewersCollection: {
        fetchOnStart: true,
        resourceOptions:{
          paginate: {
            size: 1000
          }
        },
        collection: ReviewerPersonModel.Collection,
      },
      settingsModel: {
        model: SettingsModel,
        fetchOnStart: true,
        fetchWhenNew: true
      },

      // models and collections needed for modals linked from my tasks
      sessionDecisionModel: {
        required: false,
        fetchOnStart: true,
        resourcePath: '@resources.disclosure.sessionDecisionModel',
      },
      outcomeCollection: {
        collection: OutcomeModel.Collection,
        required: false,
        sort: {
          field: 'description',
          direction: 'ascending',
        },
      },
      disclosureCommentModel: {
        model: DisclosureCommentModel,
      },
      previousReviewerModel: {
        required: false,
        model: PreviousReviewerModel,
      },
      routingHistoryCollection: {
        fetchOnStart: true,
        collection: ResourceQueryCollection.extend({
          model: PersonModel,
          query: {
            select: [{ from: 'RoutingHistory.*' }, { from: 'Person.firstName' }, { from: 'Person.lastName' }],
            select: [{ from: 'RoutingHistory.*' }, { from: 'Person.firstName' }, { from: 'Person.lastName' }],
            resourceClass: DisclosureRoutingHistoryModel.Collection,
            as: 'RoutingHistory',
            urlParams: {
              documentId: '@state.primaryId',
            },
            join: [
              {
                as: 'Person',
                resourceClass: PersonModel.Collection,
                joinType: 'leftOuterJoin',
                on: {
                  userAccountId: 'RoutingHistory.assignee',
                },
              },
            ],
            sort: {
              field: 'RoutingHistory.completionTime',
              direction: 'descending',
            },
          },
        }),
      },
      completedHistoryModel: {
        model: Backbone.Model,
      },
    },
    createForm: function() {
      var template = this.getResource('template');
      var form = new FormKit.Form({
        templateModel: template,
      });
      return form;
    },
  });

  module.exports = DisclosureFormTabController;
});

